import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	dialogSize: {
		height: 500
	}
})

export default useStyles
